module.exports = __webpack_public_path__ + "img/indeed1.fd1670cd.svg";